import React from "react";
import { Box, Alert, AlertTitle, Stack, Typography } from "@mui/material";

function ShowError({ message, height }) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: height ?? "100vh",
      }}
    >
      <Stack sx={{ width: `50%` }} spacing={2}>
        <Alert variant="outlined" severity="error">
          <AlertTitle>Error</AlertTitle>

          <Typography sx={{ fontWeight: "light", fontSize: 25 }}>
            {message ?? (
              <>
                <>Some of the information is missing.</>
                <br />
                <>Please re-authenticate or contact with admin.</>
              </>
            )}
          </Typography>
        </Alert>
      </Stack>
    </Box>
  );
}

export default ShowError;
